import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import './index.css';
import App from './App';
import { msalConfig } from './auth/msalConfig';
import { GuestProvider } from './auth/GuestContext';
import reportWebVitals from './reportWebVitals';

// MSAL instance must be created outside of the render tree so it survives
// remounts. Initialize once, then set the active account on login success
// so downstream code can call acquireTokenSilent without passing an account.
const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));

msalInstance.initialize().then(async () => {
  // Required by loginRedirect / logoutRedirect / acquireTokenRedirect — picks
  // up the auth response when the page loads after a sign-in roundtrip.
  await msalInstance.handleRedirectPromise().catch((e) => console.error("MSAL redirect:", e));

  const existingAccounts = msalInstance.getAllAccounts();
  if (existingAccounts.length > 0) {
    msalInstance.setActiveAccount(existingAccounts[0]);
  }

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
      msalInstance.setActiveAccount(event.payload.account);
    }
  });

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <GuestProvider>
          <App />
        </GuestProvider>
      </MsalProvider>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
